import React, { useState } from 'react';

import Iframe from '@swf/components/Iframe/Iframe';
import useNavigate from '@swf/core/hooks/useNavigate';
import useWizardContext from '@swf/core/hooks/useWizardContext';
import { FirstLoader } from '@swf/first';

import Prompt from '../../Prompt/Prompt';

import { TXTCLI_PayNearMe } from './PayNearMe.messages.json';
import { content, iframe, paper } from './PayNearMe.scss';

interface Props {
  onClose(): void;
}

const PayNearMe: React.FC<Props> = ({ onClose }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const {
    data: { payNearMeUrl }
  } = useWizardContext();

  const handleClose = () => {
    onClose();
    navigate('/');
  };

  return (
    <Prompt
      variant="blank"
      classes={{ content, paper }}
      title={{ translation: TXTCLI_PayNearMe }}
      onClose={handleClose}
    >
      {loading && <FirstLoader />}
      <Iframe
        className={iframe}
        src={payNearMeUrl}
        onLoad={() => setLoading(false)}
        scrolling="yes"
        data-testid="payNearMe-iframe"
      />
    </Prompt>
  );
};
export default PayNearMe;
